import { render, staticRenderFns } from "./Lyrics.vue?vue&type=template&id=2771b0ea&"
import script from "./Lyrics.vue?vue&type=script&lang=js&"
export * from "./Lyrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports